import { RootState } from "../store/community-finder-redux-store";

export const selectIsAppLoaded = (state: RootState) =>
	state?.appStatus?.appLoaded;
